export enum EApproveMemberErrorNumber {
    SystemError = 1,
    StatusChanged = 2,
    ApprovePrimaryMemberFirst = 3,
    GenerateMemberNumberError = 4,
    CreateNewMemberCardsError = 5
}
